import { CalculateOrderResponse } from '../api/cartService';

export type PromotionSource = 'STAY_AUTO' | 'USER_CODE' | 'NONE';

export interface PromotionResolution {
  source: PromotionSource;
  appliedPromotionId: string | null;
  appliedPolicyId: string | null;
}

export const getPromotionResolution = (
  calculation: CalculateOrderResponse | null
): PromotionResolution => {
  if (!calculation) {
    return {
      source: 'NONE',
      appliedPromotionId: null,
      appliedPolicyId: null,
    };
  }

  return {
    source: calculation.promotionSource ?? 'NONE',
    appliedPromotionId: calculation.appliedPromotionId ?? null,
    appliedPolicyId: calculation.appliedPolicyId ?? null,
  };
};
